"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonusConditionsData = void 0;
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var useBonusConditionsData = function (data) {
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var formatCurrency = (0, swr_hooks_1.useCurrencyFormat)();
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'title',
                    label: '',
                },
                {
                    field: 'welcome',
                    label: t('welcome'),
                },
                {
                    field: 'vip',
                    label: t('vip'),
                },
            ],
            rows: [],
        };
        table.rows = data.map(function (_a) {
            var key = _a.key, value = _a.value, welcomeValue = _a.welcomeValue;
            return {
                title: t(key),
                welcome: key === 'maxBet'
                    ? formatCurrency(welcomeValue)
                    : key === 'wager'
                        ? "".concat(welcomeValue, "x")
                        : formatCurrency(welcomeValue),
                vip: (react_1.default.createElement("span", null, key === 'maxBet'
                    ? formatCurrency(value)
                    : key === 'wager'
                        ? "".concat(value, "x")
                        : formatCurrency(value))),
            };
        });
        return table;
    }, [data, t, formatCurrency]);
};
exports.useBonusConditionsData = useBonusConditionsData;
